<template>
  <div class="auth-component">
    <!-- Utente non autenticato -->
    <div v-if="!store.isAuthenticated" class="d-flex align-items-center">
      <button 
        @click="store.login()" 
        :disabled="store.loadingAuth"
        class="btn btn-outline-primary me-2"
      >
        <i class="fas fa-sign-in-alt me-1"></i>
        {{ store.loadingAuth ? 'Caricamento...' : 'Accedi' }}
      </button>
    </div>

    <!-- Utente autenticato -->
    <div v-else class="d-flex align-items-center">
      <div class="dropdown">
        <button 
          class="btn btn-outline-success dropdown-toggle" 
          type="button" 
          id="userMenu" 
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <i class="fas fa-user me-1"></i>
          {{ store.getUserName }}
        </button>
        <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="userMenu">
          <li>
            <h6 class="dropdown-header">
              <i class="fas fa-info-circle me-1"></i>
              Informazioni Utente
            </h6>
          </li>
          
          <!-- Sezione Profili Disponibili -->
          <template v-if="availableProfiles.length > 0">
            <li><hr class="dropdown-divider"></li>
            <li>
              <h6 class="dropdown-header">
                <i class="fas fa-users me-1"></i>
                Cambia Profilo
              </h6>
            </li>
            <li v-for="profile in availableProfiles" :key="profile.uid">
              <button 
                @click="switchProfile(profile)" 
                class="dropdown-item"
              >
                <i class="fas fa-user-circle me-2"></i>
                {{ profile.name }}
              </button>
            </li>
          </template>
          
          <li><hr class="dropdown-divider"></li>
          <li>
            <button @click="handleLogout" class="dropdown-item">
              <i class="fas fa-sign-out-alt me-1"></i>
              Logout
            </button>
          </li>
        </ul>
      </div>
    </div>

    <!-- Mostra errori -->
    <div v-if="store.authError" class="alert alert-warning alert-dismissible fade show mt-2" role="alert">
      <i class="fas fa-exclamation-triangle me-1"></i>
      {{ store.authError }}
      <button @click="clearError" type="button" class="btn-close" aria-label="Close"></button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useAppStore } from '../stores/app.js'

const store = useAppStore()

// Computed property per ottenere i profili disponibili (escluso quello corrente)
const availableProfiles = computed(() => {
  if (!store.user?.profiles || !Array.isArray(store.user.profiles)) {
    return []
  }
  
  const currentUid = store.user?.superuser?.uid || store.user?.uid
  
  // Filtra i profili escludendo quello con uid corrente
  return store.user.profiles.filter(profile => profile.uid !== currentUid)
})

// Funzione per cambiare profilo
async function switchProfile(profile) {
  console.log('Switching to profile:', profile)
  store.switchProfile(profile);
}

function handleLogout() {
  console.log(store.user)
  store.logout()
}

function clearError() {
  store.clearError()
}
</script>
